import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function bodyEmail() {
    return {
        index,
        create,
        update,
        getBodyEmailDetail,
        deleteBodyEmail,
        getBodyEmailTableclass
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`body-email/search${params}`);
    }

    function getBodyEmailDetail(id) {
        return axiosInstance.get(`body-email/get?id=${id}`);
    }

    function getBodyEmailTableclass(tableClass) {
        return axiosInstance.get(
            `body-email/get-tableclass?tableClass=${tableClass}`
        );
    }

    function create(payload) {
        return axiosInstance.post(`body-email/create`, JSON.stringify(payload));
    }

    function update(payload) {
        return axiosInstance.patch(
            `body-email/update`,
            JSON.stringify(payload)
        );
    }

    function deleteBodyEmail(payload) {
        return axiosInstance.delete(`body-email/delete`, {
            data: JSON.stringify(payload)
        });
    }
}
